interface UrlConfig {
    baseUrl: string;
    locale?: string;
}

interface SearchUrlParams {
    contentType?: string;
    id?: string | number;
}
// TODO: basic url builder. Better mapping to be done
export class UrlBuilder {
    private readonly config: UrlConfig;

    constructor(config: UrlConfig) {
        this.config = config;
    }

    // TODO: To be mapped better for other locales
    private getLocalizedDomain(): string {
        const { baseUrl, locale } = this.config;

        if (!locale) {
            return baseUrl;
        }

        return baseUrl.replace(".com", `.${locale}`);
    }

    buildSearchUrl(params: SearchUrlParams = {}): string {
        const baseUrl = this.getLocalizedDomain();
        const { contentType, id } = params;

        if (contentType === "category" && id) {
            return `${baseUrl}/search/categories/${id}/`;
        }

        if (contentType === "collection" && id) {
            return `${baseUrl}/search/collections/${id}/`;
        }

        return `${baseUrl}/search/`;
    }

    buildAdvancedSearchUrl(params: SearchUrlParams = {}): string {
        const baseUrl = this.buildSearchUrl(params);
        return `${baseUrl}?searchMode=advanced`;
    }
}

export const createUrlBuilder = (locale?: string): UrlBuilder =>
    new UrlBuilder({
        baseUrl: "https://ancestrystage.com",
        locale,
    });
